import React from 'react';
import { Empty } from 'antd';
import { useAvailableDeskNames } from '../../../controllers/DesksDataTracker';
import SelectDeskName from '../../../controllers/SelectDeskName';
import { useOpenCreateDeskModal } from '../../../controllers/SetDeskName';
import Btn, { btnTypes } from '../../../../../components/btn';
import OptionButton from '../../../shared/ui/OptionButton';
import { useDeleteDesk } from '../../../controllers/deleteDesk';
import { useDeskIsImmutable } from '../hooks/isImmutableFns';
import styles from './index.module.scss';

const SelectDeskNameBlock = ({ index }) => {
  const names = useAvailableDeskNames();

  const disabled = useDeskIsImmutable(index);

  return (
    <SelectDeskName
      deskIndex={index}
      names={names}
      notDeskNamesContent={NotDeskNamesContent}
      renderActionsForOption={RenderActionsForOption}
      disabled={disabled}
    />
  );
};

export default SelectDeskNameBlock;

function NotDeskNamesContent() {
  const openCreateDeskModal = useOpenCreateDeskModal();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="Нет доступных столов"
    >
      <Btn type={btnTypes.primary} onClick={openCreateDeskModal}>
        Создать стол
      </Btn>
    </Empty>
  );
}

function RenderActionsForOption({ id, name }) {
  return (
    <div className={styles.flexWrap}>
      <EditDeskNameButton id={id} name={name} />
      <DeleteDeskNameButton id={id} />
    </div>
  );
}

function EditDeskNameButton(props) {
  const openCreateDeskModal = useOpenCreateDeskModal();

  const handleClick = (e) => {
    e.stopPropagation();
    openCreateDeskModal(props);
  };

  return (
    <OptionButton
      type={OptionButton.types.primaryInvert}
      icon="edit"
      tooltipTitle="Изменить наименование"
      onClick={handleClick}
    />
  );
}

function DeleteDeskNameButton({ id }) {
  const { isCheckDeskLoading, onDelete } = useDeleteDesk(id);

  const handleClick = (e) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <OptionButton
      type={OptionButton.types.danger}
      icon={isCheckDeskLoading ? 'loading' : 'delete'}
      tooltipTitle="Удалить стол"
      onClick={handleClick}
    />
  );
}
